var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTesttube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "ext1_2",
    x: 0.544922,
    width: 40,
    height: 40,
    rx: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "ext1_2_i",
    d: "M24.9391 9.87821C24.4998 9.43887 23.7874 9.43887 23.3481 9.87821C23.0017 10.2246 22.9284 10.7406 23.1282 11.1588L11.4157 22.8713C9.65832 24.6287 9.65832 27.4779 11.4157 29.2353C13.173 30.9927 16.0223 30.9927 17.7796 29.2353L29.4922 17.5227C29.9104 17.7225 30.4264 17.6492 30.7727 17.3028C31.2121 16.8635 31.2121 16.1512 30.7727 15.7118L24.9391 9.87821ZM24.1436 12.2647L28.3863 16.5074L26.0853 18.8083L18.2286 18.1798L19.6358 16.7726L20.829 17.9658C21.0487 18.1855 21.4049 18.1855 21.6245 17.9658C21.8442 17.7461 21.8442 17.39 21.6245 17.1703L20.4313 15.9771L24.1436 12.2647ZM17.2493 19.1591L18.4425 20.3523C18.6622 20.572 18.6622 20.9281 18.4425 21.1478C18.2228 21.3675 17.8667 21.3675 17.647 21.1478L16.4538 19.9546L17.2493 19.1591ZM14.0674 22.341L15.2606 23.5342C15.4803 23.7539 15.4803 24.1101 15.2606 24.3297C15.0409 24.5494 14.6848 24.5494 14.4651 24.3297L13.2719 23.1365L14.0674 22.341Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTesttube);
export default __webpack_public_path__ + "static/media/Testtube.7e656fda.svg";
export { ForwardRef as ReactComponent };